import YouTube, { YouTubeProps } from "react-youtube";

const Video = () => {
  const onPlayerReady: YouTubeProps["onReady"] = (event: any) => {
    const player = event.target;
    player.mute();
    player.playVideo();
  };

  const onPlayerStateChange: YouTubeProps["onStateChange"] = (event: any) => {
    if (event.data === 0) {
      const player = event.target;
      player.seekTo(5);
      player.playVideo();
    }
  };

  const opts: YouTubeProps["opts"] = {
    playerVars: {
      width: "100%", // 너비 100% 설정
      start: 5,
      autoplay: 1, // 자동 재생
      autohide: 1,
      modestbranding: 0, // YouTube 로고 최소화
      mute: 1, // 음소거
      controls: 0, // 컨트롤 바 숨김
      rel: 0, // 관련 동영상 숨김
      fs: 0, // 전체 화면 버튼 제거
      iv_load_policy: 3, // 인포메이션 창 숨김
      showinfo: 0, // 영상 제목 숨김 (일부 브라우저에서 동작하지 않을 수 있음)
      disablekb: 1, // 키보드 컨트롤 비활성화
      loop: 1, // 무한 반복
      playlist: "a6p6BHcpf-4", // 무한 반복을 위해 필요
    },
  };

  return (
    <>
      {/* <iframe
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        title="한국셔플댄스협회 홈페이지 메인 영상"
        height={600}
        src="https://www.youtube.com/a6p6BHcpf-4"
        // autoplay=1&amp;autohide=1&amp;modestbranding=0&amp;rel=0&amp;showinfo=0&amp;controls=0&amp;disablekb=1&amp;enablejsapi=1&amp;iv_load_policy=3&amp;origin=https%3A%2F%2Fshuffledance.kr&amp;widgetid=1
        // style="left: -168.5px;top: -10px;display: none;"
      ></iframe> */}

      <div
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: "45.25%",
          height: 0,
          overflow: "hidden",
        }}
      >
        <iframe
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          src="https://www.youtube.com/embed/nLQ-nk31frg?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&fs=0&iv_load_policy=3&disablekb=1&loop=1&playlist=nLQ-nk31frg&enablejsapi=1"
          allow="autoplay; encrypted-media"
          allowFullScreen
          frameBorder="0"
        />

        {/* <YouTube
        videoId="a6p6BHcpf-4"
        opts={opts}
        onReady={onPlayerReady}
        onStateChange={onPlayerStateChange}
      /> */}
      </div>
    </>
  );
};

export default Video;
